// extracted by mini-css-extract-plugin
export default {"importCsvCard":"AddDetails_importCsvCard__LiA7s","addBtnContainer":"AddDetails_addBtnContainer__IWKaJ"};